'use client';
import cn from 'classnames';

import { SubscriptionProduct } from '@/types/Subscription';
import PlanCarousel from '@/components/common/PlanCarousel/PlanCarousel';
import PlanCardCondensed from '@/components/common/PlanCardCondensed/PlanCardCondensed';

import './SignUpPlanCardList.style.scss';

type PlanCardListProps = {
  className?: string;
  subs: SubscriptionProduct[];
  onPlanSelected?: (selectedPlanValue: SubscriptionProduct) => void;
  selectedPlanValue?: SubscriptionProduct;
  onCloseModal?: () => void;
  isPremierAddOnSelected?: boolean;
};

function SignUpPlanCardList(props: PlanCardListProps) {
  const {
    className = '',
    subs,
    onPlanSelected,
    onCloseModal,
    selectedPlanValue,
    isPremierAddOnSelected = false
  } = props;

  return (
    <div className={cn('SignUpPlanCardList', className)}>
      <div className='SignUpPlanCardList-nav'>
        <div className='PlanChoice button-wrapper'>
          <button
            className='PlanChoice-save SignUpSummaryBar-edit-button cursor cursor'
            onClick={onCloseModal}
            type='button'
          >
            Save
          </button>
        </div>
      </div>

      <PlanCarousel>
        {subs
          .filter((plan) => !plan.slug.match(/premier/i))
          .map((plan) => {
            return (
              <PlanCardCondensed
                key={plan.name}
                planData={plan}
                selectedPlanValue={selectedPlanValue}
                onPlanSelected={(selectedPlanValue) => {
                  onPlanSelected?.(selectedPlanValue);
                }}
                disabled={isPremierAddOnSelected && plan.slug === 'premier'}
              />
            );
          })}
      </PlanCarousel>
    </div>
  );
}

export default SignUpPlanCardList;
